<template>
  <div id="post-content" ref="element" v-cleaned="content" />
</template>
<script setup lang="ts">
interface Props {
  content: string;
}
defineProps({
  content: null
});
const emit = defineEmits(["ready"]);
const element = ref(null);
useMathJax(element, () => {
  emit('ready');
});
</script>
<style lang="scss">
#post-content {
  // --color_primary: #f66929;
  --color_resume: var(--color_secondary);
  --color_resume_light: var(--color_secondary_lighter);
  --color_exemple: #e2deff;
  --color_mark: #fcdede;
  --color_dark_grey: #5b5b5b;

  table {
    word-break: break-word;
    td,
    th {
      min-width: 10vw;
    }
  }

  h1 {
    margin: 2.5rem 0;
    font-family: Lato, sans-serif;
    font-size: 3.2rem;
    font-weight: 800;
    line-height: 1.3;
    text-align: center;
  }

  h2 {
    margin: 2.5rem 0;
    font-family: Lato, sans-serif;
    font-size: 2.6rem;
    font-weight: bold;
    line-height: 1.3;
    text-align: center;
  }

  h3 {
    margin: 2rem 0;
    color: var(--color_primary);
    font-family: Lato, sans-serif;
    font-size: 2rem;
    font-weight: bold;
    line-height: 1.2;
  }

  h4 {
    margin: 1.5rem 0 1rem;
    font-family: Lato, sans-serif;
    font-size: 1.8rem;
    font-weight: 600; /* Semi-Bold */
  }

  h5 {
    margin: 1rem 0;
    color: var(--color_dark_grey);
    font-family: Lato, sans-serif;
    font-size: 1.7rem;
    font-style: italic;
    font-weight: 400;
  }

  p {
    margin: 1rem 0;
    font-size: 1.6rem;
    font-weight: 400;
  }

  mark {
    background-color: var(--color_mark) !important;
    font-weight: bold;
  }

  section {
    margin: 2rem 0;
  }

  section h2 {
    color: var(--color_resume);
    font-family: Lato, sans-serif;
    font-size: 2.2rem;
    font-weight: bold;
    text-align: center;
  }

  section aside {
    padding: 1rem;
    border: 0.2rem solid var(--color_resume);
    border-radius: 1rem;
    background-color: var(--color_resume_light);
    font-size: 1.6rem;
  }

  kbd {
    display: inline-block;
    margin-right: 0.5rem;
    padding: 0 0.8rem 0.1rem 0.2rem;
    border: none;
    background-color: var(--color_exemple) !important;
    color: black !important;
    font-family: Lato, sans-serif;
    font-size: 1.6rem;
    font-weight: 800;
    clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%);
  }

  blockquote {
    margin: 30px;
    color: #767676;
    font-weight: normal;
    text-align: center;
  }

  #loader {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    text-align: center;
  }

  img {
    // width: 100%;
    // height: auto;
    // text-align: center;
  }

  img:not(.adjusted) {
    /** Scale by default to match the width of the container, all img but the img with defined width and height set inline and that should be kept. Theses should be configured with .adjusted class */
    // width: 100%;
  }

  img.adjusted {
    @include mobile {
      max-width: 32rem;
    }

    max-width: 60rem;
    height: auto;
  }

  /* For MathJax wording (other than SVG equation) */
  .emphasize {
    color: var(--color_primary);
  }

  .warning {
    display: flex;
  }

  .warning-text {
    padding: 10px;
    border: solid;
    border-width: 2px;
    border-radius: 10px;
    border-color: var(--color_primary);
    background-color: var(--color_warning);
  }

  .centered-element {
    position: relative;
    top: 50%;
    margin: 0;
    transform: translateY(-50%);
  }

  .warning-icon {
    display: inline-block;
    margin-right: 20px;
    padding: 10px;
    border: solid;
    border-width: 2px;
    border-radius: 10px;
    border-color: var(--color_primary);
    color: var(--color_primary);
    text-align: center;
  }
  .hole {
    color: var(--color_primary);
  }
  .practice {
    color: var(--color_primary);
  }

  ol {
    list-style: none;
    counter-reset: cupcake;
  }
  ol > li {
    counter-increment: cupcake;
  }
  ol > li::before {
    content: counters(cupcake, '.') '. ';
  }

  iframe {
    width: 100%;
    aspect-ratio: 16/9;
    border: 0;
  }

  /* font-style: italic; */

  a {
    text-decoration: underline;
    @include hover-focus-desktop {
      color: var(--color_secondary);
    }
  }
}
</style>
